import { render, staticRenderFns } from "./TesteAB.vue?vue&type=template&id=728a764f&"
import script from "./TesteAB.vue?vue&type=script&lang=js&"
export * from "./TesteAB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports